export default "__VITE_ASSET__vz$6c2QV__"